//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import React from 'react';

import LessonMode from '../__lesson-mode/assignment__lesson-mode';

interface Props {
    lessonMode: CLESSON_MODES;
    disabled: boolean;
    onSelectMode: (mode: CLESSON_MODES) => void;
}

export const AssignmentLessonTypeMode = React.memo((props: Props) => {
    const { lessonMode, disabled, onSelectMode } = props;

    return (
        <LessonMode currentMode={lessonMode} disabled={disabled} onSelectMode={onSelectMode} shouldShowError={false} />
    );
});
